/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export interface DisambiguationModalProps {
  title: string;
  content: JSX.Element;
  buttons: {
    content: JSX.Element;
    onClick: () => void;
    outline?: boolean;
  }[];
  toggle: () => void;
}

const DisambiguationModal = (props: DisambiguationModalProps) => {
  const { title, content, buttons, toggle } = props;

  return (
    <Modal isOpen={true} toggle={toggle} backdrop='static'>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {content}
      </ModalBody>
      <ModalFooter>
        {buttons.map((button, i) => (
          <Button size='sm' key={`btn_${i}`} onClick={button.onClick} outline={button.outline}>
            {button.content}
          </Button>
        ))}
      </ModalFooter>
    </Modal>
  );
};

export default DisambiguationModal;
